module.exports = __webpack_public_path__ + "img/list.ad870789.svg";